var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-area__inner no-padding no-scroll-y"},[_c('ContentAreaTitle',{ref:"titleBar",attrs:{"icon":_vm.$store.getters.project.logo_url,"title":_vm.$store.getters.project.name,"subtitle":_vm.$store.getters.project.description ? _vm.$store.getters.project.description : 'N/A',"tabs":_vm.$router.options.routes[2].children[1].children}},[_c('template',{slot:"image"},[_c('ImageUploader',{staticStyle:{"float":"left","margin-right":"10px"},attrs:{"small":true,"url":_vm.$store.getters.project.logo_url,"project":_vm.$store.getters.project.id}})],1)],2),_vm._v(" "),_c('router-view',{key:"project",style:({
		'display': 'block',
		'position': 'absolute',
		'height': 'auto',
		'margin-top': (_vm.titleBarHeight + "px"),
		'top': 0,
		'right': 0,
		'left': 0,
		'bottom': 0
	})})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-244d4dcc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Projects/Project/Project.vue
// module id = null
// module chunks = 